import React from 'react';
import {Dialog, DialogContent, DialogActions, TextField} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

export default function UpdateInfo ({info, open, onClose}) {
    const {author, timestamp, commit} = info.values;
    return (
        <div>
            <Dialog open={open} onClose={onClose}>
                <AppBar position="static" color="primary">
                    <Toolbar>
                        <div><Typography variant="h5">Update Information</Typography></div>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <TextField
                        disabled={true}
                        className="text-field"
                        color="primary"
                        fullWidth
                        label="Veranlasser"
                        value={author}
                        variant="standard"
                        InputLabelProps={{shrink: true}}
                    />
                    <TextField
                        style={{marginTop: 20}}
                        disabled={true}
                        className="text-field"
                        color="primary"
                        fullWidth
                        label="Updatezeitpunkt"
                        value={timestamp}
                        variant="standard"
                        InputLabelProps={{shrink: true}}
                    />
                    <TextField
                        style={{marginTop: 20}}
                        disabled={true}
                        className="text-field"
                        color="primary"
                        fullWidth
                        label="Kommentar"
                        value={commit}
                        variant="standard"
                        InputLabelProps={{shrink: true}}
                    />
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={onClose}>Verlassen</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
